import { render, staticRenderFns } from "./ModuleTabsManagement.vue?vue&type=template&id=25b43848&scoped=true"
import script from "./ModuleTabsManagement.vue?vue&type=script&lang=ts"
export * from "./ModuleTabsManagement.vue?vue&type=script&lang=ts"
import style0 from "./ModuleTabsManagement.vue?vue&type=style&index=0&id=25b43848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b43848",
  null
  
)

export default component.exports